// Per-app `environment.scopes` map, made available to reducer/selector code that has no
// DI access (reducers are plain functions). Each app calls `setScopeConfig` once, at
// AppModule load time, with its own `environment.scopes`.
// Intentionally loose — each app's `environment.scopes` has its own concrete shape
// (EnvironmentScopes); this util only ever does a keyed lookup on it.
type ScopeConfig = Record<string, any>;

let scopes: ScopeConfig = {};

export function setScopeConfig(config: ScopeConfig): void {
	scopes = config || {};
}

export const getConfigByScope = (configKey: string) => {
	try {
		let scope = localStorage.getItem('selectedOrganization');
		if (!scope) {
			scope = document.location.hostname.split('.')[0];
		}
		scope = scope.toLowerCase();
		return (scopes[scope] && scopes[scope][configKey]) || null;
	} catch (e) {
		return false;
	}
};
